<div class="w-full lg:max-w-7xl p-8">
    <div class="prose prose-sm !max-w-100">
        <h2>Breytingasaga</h2>
        <h3>Hér færð þú yfirlit yfir breytingasögu í ytri kerfum</h3>
    </div>
    <mat-divider class="my-4"></mat-divider>

    <div id="header" class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-6 px-0 !pt-1 mb-2">
        <form [formGroup]="form" #profileInNgForm="ngForm">
            <div class="flex flex-col mt-4 sm:flex-row">
                <div class="flex-auto w-full sm:w-auto">
                    <mat-form-field class="fuse-mat-no-subscript w-full sm:w-[90%] top-[5px] mb-1">
                        <mat-select placeholder="Kerfi" formControlName="system">
                            @for (system of systemsDropDown; track system) {
                            <mat-option [value]="system.value">{{ system.viewValue }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="fuse-mat-no-subscript w-full sm:w-[90%] top-[15px] mb-1">
                        <span class="mr-[18px]" matPrefix>Frá:</span>
                        <input class="date" formControlName="dateFrom" matInput placeholder="Dagsetning (frá)"
                            (click)="dateFrom.open()" [matDatepicker]="dateFrom" />
                        <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                        <mat-datepicker #dateFrom></mat-datepicker>
                        @if (this.form?.get('dateFrom')?.hasError('required')) {
                        <mat-error> Það <strong>þarf</strong> að velja dagsetningu </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="fuse-mat-no-subscript w-full sm:w-[90%] top-[25px] mb-1">
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                        <input formControlName="searchString" matInput [placeholder]="'Leita'"
                            (keydown.enter)="clickFetchData()" />
                        @if (this.form?.get('searchString')?.value?.length === 0) {
                        <mat-hint> Settu inn leitarorð </mat-hint>
                        }
                    </mat-form-field>
                </div>
                <div class="flex-auto w-full sm:w-auto">
                    <mat-form-field class="fuse-mat-no-subscript w-full sm:w-full top-[5px] mb-1">
                        <mat-select placeholder="Tegund" formControlName="type">
                            <mat-option [value]="allTablesValue">{{ 'label_all' | translate }}</mat-option>
                            @for (table of tablesDropDown; track table) {
                            <mat-option [value]="table.value">{{ table.viewValue }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="fuse-mat-no-subscript w-full sm:w-full top-[15px] mb-1">
                        <span class="mr-[18px]" matPrefix>Til:</span>
                        <input class="date" formControlName="dateTo" matInput placeholder="Dagsetning (til)"
                            (click)="dateTo.open()" [matDatepicker]="dateTo" />
                        <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                        <mat-datepicker #dateTo></mat-datepicker>
                        @if (this.form?.get('dateTo')?.hasError('required')) {
                        <mat-error> Það <strong>þarf</strong> að velja dagsetningu </mat-error>
                        }
                    </mat-form-field>

                    <div class="flex justify-end mr-2">
                        <button class="ml-4 min-w-[120px] w-full sm:w-auto sm:mt-[0px] top-[35px]" mat-flat-button
                            [color]="'primary'" (click)="clickFetchData()">
                            <mat-icon [svgIcon]="'heroicons_solid:search'"></mat-icon>
                            <span class="ml-2 mr-1 block">Leita</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <ng-container>
        <div>
            <div class="flex flex-wrap -m-2 mt-10 justify-center">
                <table mat-table matSort #sortContributionsParent="matSort" [dataSource]="dataSource"
                    class="w-full table-expandable">
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>Númer</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.id }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>Tegund</th>
                        <td mat-cell *matCellDef="let element">
                            {{ 'label_external_system_table_' + element.type | translate }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="valueBeforeChange">
                        <th mat-header-cell *matHeaderCellDef>Gildi fyrir breytingu</th>
                        <td mat-cell *matCellDef="let element">
                            <div [innerHTML]="element.valueBeforeChange"></div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="valueAfterChange">
                        <th mat-header-cell *matHeaderCellDef>Nýtt gildi</th>
                        <td mat-cell *matCellDef="let element">
                            <div [innerHTML]="element.valueAfterChange"></div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="changeDate">
                        <th mat-header-cell *matHeaderCellDef>Dags breytt</th>
                        <td mat-cell *matCellDef="let element">
                            {{ formatDate(element.changeDate) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="changedBy">
                        <th mat-header-cell *matHeaderCellDef>Breytt af</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.changedBy }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                    <tr class="hover:opacity-70 hover:cursor-pointer" mat-row
                        *matRowDef="let logrow; columns: tableColumns"></tr>
                </table>
            </div>
            <mat-paginator #paginator id="logPaginator" [length]="totalData" [pageSizeOptions]="pageSizes"
                [pageSize]="pageSize" showFirstLastButtons>
            </mat-paginator>
        </div>
        @if (totalData == 0 && !isLoading) {
        <div class="flex flex-col flex-auto items-center justify-center p-6 sm:p-10">
            <div
                class="mt-12 sm:mt-24 text-4xl md:text-7xl font-extrabold tracking-tight leading-tight md:leading-none text-center">
                Engin skráning fannst
            </div>
            <div class="mt-2 text-lg md:text-xl font-medium tracking-tight text-center text-secondary">
                Engin skráning fannst undir völdu leitarskilyrði
            </div>
        </div>
        }
    </ng-container>
</div>